import React, { useEffect, useState } from "react";
import "./../../index.css";
import * as api from "./../../api/api";
import * as c from "./../../const";

import Menu from "./../menu/menu";

export default function Header() {
  const [logo, setLogo] = useState("");
  useEffect(() => {
    companyAPI();
  }, []);

  const companyAPI = async () => {
    try {
      const response = await api.company();
      setLogo(response[0].logo);
    } catch (e) {}
  };

  const url = c.URL;
  let src = `${url}/${logo}`;
  return (
    <>
      <div className="logo-area">
        <div className="row align-items-center">
          
          <div className="col-lg-12 col-md-6 col-sm-6 text-center">
            <div className="logo-heading">
              <h2 className="uppercase">
                GENERAL AVIATION. DIRECT & UNFILTERED
              </h2>
            </div>
            <div className="logo-box pl-lg-5">
              <a href="/">
                <img src={src} className="img-fluid pl-lg-4" alt="logo" />
              </a>
            </div>
          </div>
        </div>
      </div>
      <Menu />
    </>
  );
}
